// @ts-nocheck
import * as Types from "../../../../types/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type IndexAdvisorConfigQueryVariables = Types.Exact<{
  databaseId: Types.Scalars["ID"]["input"];
  tableId: Types.Scalars["ID"]["input"];
}>;

export type IndexAdvisorConfigQuery = {
  __typename?: "GraphqlQuery";
  getSchemaTableIndexAdvisorConfig: {
    __typename?: "IndexAdvisorConfigForTable";
    id: string;
    parentTableId?: string | null;
    queries?: number | null;
    writesPerMin?: number | null;
    scansPerMin?: number | null;
    tableSize?: number | null;
    settings?: any | null;
    settingsName: string;
    defaultPreset?: string | null;
    lastRunAt?: number | null;
    permittedToEdit: boolean;
  };
};

export const IndexAdvisorConfigDocument = gql`
  query IndexAdvisorConfig($databaseId: ID!, $tableId: ID!) {
    getSchemaTableIndexAdvisorConfig(
      databaseId: $databaseId
      schemaTableId: $tableId
    ) {
      id
      parentTableId
      queries
      writesPerMin
      scansPerMin
      tableSize
      settings
      settingsName
      defaultPreset
      lastRunAt
      permittedToEdit
    }
  }
`;

/**
 * __useIndexAdvisorConfigQuery__
 *
 * To run a query within a React component, call `useIndexAdvisorConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useIndexAdvisorConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIndexAdvisorConfigQuery({
 *   variables: {
 *      databaseId: // value for 'databaseId'
 *      tableId: // value for 'tableId'
 *   },
 * });
 */
export function useIndexAdvisorConfigQuery(
  baseOptions: Apollo.QueryHookOptions<
    IndexAdvisorConfigQuery,
    IndexAdvisorConfigQueryVariables
  > &
    (
      | { variables: IndexAdvisorConfigQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    IndexAdvisorConfigQuery,
    IndexAdvisorConfigQueryVariables
  >(IndexAdvisorConfigDocument, options);
}
export function useIndexAdvisorConfigLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IndexAdvisorConfigQuery,
    IndexAdvisorConfigQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    IndexAdvisorConfigQuery,
    IndexAdvisorConfigQueryVariables
  >(IndexAdvisorConfigDocument, options);
}
// @ts-ignore
export function useIndexAdvisorConfigSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    IndexAdvisorConfigQuery,
    IndexAdvisorConfigQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  IndexAdvisorConfigQuery,
  IndexAdvisorConfigQueryVariables
>;
export function useIndexAdvisorConfigSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        IndexAdvisorConfigQuery,
        IndexAdvisorConfigQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  IndexAdvisorConfigQuery | undefined,
  IndexAdvisorConfigQueryVariables
>;
export function useIndexAdvisorConfigSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        IndexAdvisorConfigQuery,
        IndexAdvisorConfigQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    IndexAdvisorConfigQuery,
    IndexAdvisorConfigQueryVariables
  >(IndexAdvisorConfigDocument, options);
}
export type IndexAdvisorConfigQueryHookResult = ReturnType<
  typeof useIndexAdvisorConfigQuery
>;
export type IndexAdvisorConfigLazyQueryHookResult = ReturnType<
  typeof useIndexAdvisorConfigLazyQuery
>;
export type IndexAdvisorConfigSuspenseQueryHookResult = ReturnType<
  typeof useIndexAdvisorConfigSuspenseQuery
>;
export type IndexAdvisorConfigQueryResult = Apollo.QueryResult<
  IndexAdvisorConfigQuery,
  IndexAdvisorConfigQueryVariables
>;
